import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e97e3c6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scene.less?vue&type=style&index=0&id=6e97e3c6&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=6e97e3c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e97e3c6",
  null
  
)

export default component.exports